module.exports = __webpack_public_path__ + "static/media/card_s2b.9ecc62d6.jpg";